document.addEventListener("DOMContentLoaded", function() {
    if (document.body.classList.contains('no_hw__facilitators')) {
        var paragraph = document.createElement("h1");
        paragraph.textContent = "You don't have permission to view this page.";
         paragraph.classList.add('hw--error-message');
      
        var mainContent = document.getElementById("MainContent");
        mainContent.appendChild(paragraph);
        
        mainContent.style.display = "block";
        mainContent.style.textAlign = "center"; 
        mainContent.style.display = "block !important";
    }

    if (document.body.classList.contains('hw--login-redirect')) {
        window.location = "/account/login";
    }
});


